module.exports = __webpack_public_path__ + "img/fossilImg2.1fa577d0.jpg";